(function() {
  'use strict';

  angular.module('ringbaPortal').directive('datetimepicker', datetimepicker);

  function datetimepicker(
    _,
    moment
  ) {
    'ngInject';

    const template = '<div class="daterangepicker dropdown-menu">' +
        '<div class="calendar left">' +
            '<div class="calendar-table"></div>' +
            '<div class="daterangepicker_input p-b-5">' +
              '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
              '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
              '<div class="calendar-time">' +
                '<div></div>' +
                '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
              '</div>' +
            '</div>' +
        '</div>' +
        '<div class="calendar right">' +
            '<div class="daterangepicker_input">' +
              '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
              '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
              '<div class="calendar-time">' +
                '<div></div>' +
                '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
              '</div>' +
            '</div>' +
            '<div class="calendar-table"></div>' +
        '</div>' +
        '<div class="ranges">' +
            '<div class="range_inputs">' +
                '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                '<button class="cancelBtn" type="button"></button>' +
            '</div>' +
        '</div>' +
    '</div>';

    const directive = {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        date: '<',
        removeInput: '&'
      },
      link: link,
      templateUrl: '/scripts/shared/directives/datetimepicker/datetimepicker.view.html'
    };
    return directive;

    function link(scope, element, attributes, ngModelCtrl) {
      let picker;
      const viewInputFormat = 'D MMM YYYY, hh:mm A';
      const modelInputFormat = 'MM/DD/YYYY hh:mm A';
      const inputElement = element.find('input');

      const options = {
        timePicker: true,
        singleDatePicker: true,
        showDropdowns: true,
        buttonClasses: 'btn',
        applyClass: 'btn-primary btn-sm',
        cancelClass: 'btn-file btn-sm m-l-10',
        autoUpdateInput: true,
        locale: {
          format: viewInputFormat
        },
        template: template
      };

      init();

      function init() {
        setupPicker();
        _resetModelValue();
      }

      function setupPicker() {
        const minDate = _getMinimumDate();
        inputElement.daterangepicker(_.merge(options, { minDate: minDate } ), callback);
        picker = inputElement.data('daterangepicker');
        picker.container.addClass('datetimepicker--no-ranges');
      }

      function _getMinimumDate() {
        if (scope.date) {
          const previousDay = moment().subtract(1, 'days');
          const selectedDate = moment(scope.date);
          return selectedDate.isAfter(previousDay) ? previousDay : selectedDate;
        } else {
          return moment().subtract(1, 'days');
        }
      }

      function callback(startDate) {
        ngModelCtrl.$setViewValue(moment(startDate).format(viewInputFormat));
      }

      // View to model
      ngModelCtrl.$parsers.unshift(function (inputValue) {
        return moment(inputValue).format(modelInputFormat);
      });

      // Model to view
      ngModelCtrl.$formatters.unshift(function (inputValue) {
        return moment(inputValue).format(viewInputFormat);
      });

      ngModelCtrl.$render = function() {
        picker.setStartDate(ngModelCtrl.$viewValue);
        picker.setEndDate(ngModelCtrl.$viewValue);
      };

      function _resetModelValue() {
        // Force scope model value and ngModel value to be out of sync to re-run formatters
        ngModelCtrl.$modelValue = null;
      }
    }
  }
})();
